export const AnalyzeTrendsIntroText =
    "Sure! I can surface trends in your filtered conversations. How would you like to start?";
export const AnalyzeTrendsOverviewText = "Provide a high-level overview";
export const AnalyzeTrendsQuestionText = "I have a specific question in mind";
